<div class="video-container" id="videoContainer">
    <div *ngFor="let video of videos; let i = index" class="video-wrapper" [id]="'videoWrapper' + i">
        <video [id]="'roleplay' + i">
            <source [src]="video" type="video/mp4">
        </video>
        <div class="progress-arc" [id]="'progress-arc' + i"></div>
    </div>
    <div id="replayButton" (click)="replay()">
        <img class="icon" src="/images/conference/replay.svg">
        <div class="replay-text">{{ "__CONFERENCE_REPLAY__" | translate }}</div>
    </div>
</div>

<app-card-button text="Listen" id="listenBtn" (click)="play()"></app-card-button>
